import React from 'react';
import { Typography } from '@mui/material';
import { PaymentAccountingRow } from 'common/types';
import ContainerBox from 'components/ContainerBox';
import { useTranslation } from 'services/localization';
import { getFeesFromPaymentAccountingRows, getReceiptRows } from '../utils';
import AccountingDataGrid from './AccountingDataGrid';

interface Props {
	rows: PaymentAccountingRow[];
	startReceiptPrint: (receiptId: string) => void;
	getExportHeaders: (reportName: string) => string[];
	getExportFileName: (reportName: string) => string;
}

const FeeTable = (props: Props) => {
	const { t } = useTranslation();
	const { rows } = props;
	const feeRows = getFeesFromPaymentAccountingRows(rows);

	return (
		<ContainerBox padding="small">
			<Typography variant="h6" gutterBottom>
				{t('reports.accounting.fees.title', 'Payment fee breakdown')}
			</Typography>
			<AccountingDataGrid
				rows={feeRows}
				receiptRows={(tableRow) =>
					getReceiptRows(
						'fee',
						tableRow.name,
						rows.filter((row) => tableRow.payment_ids.includes(row.paymentId)),
					)
				}
				startReceiptPrint={props.startReceiptPrint}
				exportHeaders={props.getExportHeaders(
					t('reports.accounting.fees.title', 'Payment fee breakdown'),
				)}
				exportFileName={props.getExportFileName('fee_breakdown')}
			/>
		</ContainerBox>
	);
};

export default FeeTable;
